import React, { useState } from "react";
import { Box, makeStyles, Typography, Paper } from "@material-ui/core";
import HeaderNavigation from "../../headerNavigation";
import ProfileWrapper from "../profile/ProfileWrapper";

export function ShippingAddress(props) {
  const { isMobile, showBackArrow } = props;
  const [editMode, setEdit] = useState(false);
  const signupConfig = props.retailer.components.find(
    (component) => component.block_type === "SignupBlock"
  );
  const header = props.retailer.components.find(
    (component) => component.block_type === "HeaderNavigationBlock"
  );
  const colorTheme = props.retailer.brand_design_theme;
  const cardBackgroundColor = colorTheme?.background_color
    ? colorTheme?.background_color
    : "transparent";
  const dpnInstance = props?.retailer?.dpn_instance?.dpn_instance;
  const formFields = signupConfig?.retailerFields?.formFields;

  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      overflow: "hidden",
      [theme.breakpoints.down("xs")]: {
        "& .tabPanelSection": {
          display: "none",
        },

        "& .MuiTypography-h2": {
          fontSize: "3.0rem",
        },
      },
    },
    accountInfo: {
      marginLeft: isMobile ? 0 : "8px",
      textAlign: "left",
    },
    accountID: {
      fontWeight: 700,
      fontFamily: "Switzer",
      fontSize: "18px",
      lineHeight: "27px",
      color: colorTheme?.text_color,
    },
    accountPhone: {
      fontWeight: 400,
      fontFamily: "Switzer",
      fontSize: "18px",
      lineHeight: "27px",
      color: colorTheme?.text_color,
    },
    accountDescription: {
      fontWeight: 400,
      fontFamily: "Switzer",
      fontSize: "18px",
      lineHeight: "27px",
      color: colorTheme?.text_description_color,
      // Mobile css
      [theme.breakpoints.down("sm")]: {
        fontSize: "16px",
      },
    },
    accountWebLink: {
      color: colorTheme?.link_color,
      "&:hover": {
        color: colorTheme?.link_color,
        textDecoration: "underline",
      },
    },
    content: {
      backgroundColor: cardBackgroundColor,
      padding: isMobile ? "0 10px" : "0 40px",
      outline: "none",
      textAlign: "center",
      maxWidth: "708px",
    },
    header: {
      display: "grid",
      gridTemplateColumns: "auto auto",
      padding: "10px",
      paddingLeft: isMobile ? 0 : "10px",
      "& .pageTitle": {
        paddingBottom: "30px",
        fontFamily: "Switzer",
        fontWeight: 700,
        fontSize: isMobile ? "30px" : "42px",
        lineHeight: "46.2px",
        color: colorTheme?.text_color,
      },
    },
    profileBody: {
      margin: "20px 0",
      backgroundColor: "#EEF0F2",
      borderRadius: "10px",

      "& .MuiTypography-h4": {
        padding: "20px 0",
      },

      "& .MuiTypography-h5": {
        fontWeight: 300,
        padding: "20px 0",
      },

      "& .MuiButton-root": {
        fontSize: "14px !important",
        color: "#fff !important",
      },
    },
    profileBodyMob: {
      "& .pageTitle": {
        marginTop: "10px",
        fontSize: "26px",
        marginLeft: "5px",
        fontFamily: "Switzer",
        fontWeight: 700,
        lineHeight: "66px",
      },
    },
    paper: {
      maxWidth: "100%",
      boxShadow: "none",
      backgroundColor: cardBackgroundColor,
    },
    paperMobile: {
      backgroundColor: cardBackgroundColor,
      maxWidth: 560,
      boxShadow: "none",
    },
    headerItem: {
      fontSize: "18px",
      textAlign: "right",
      marginTop: isMobile ? "15px" : "12px",
      fontWeight: 700,
      fontFamily: "Switzer",
      lineHeight: "19.8px",
      cursor: "pointer",
    },
    deleteInfo: {
      display: "grid",
      gridTemplateColumns: "auto auto",
      marginLeft: "5px",
    },
    delteItem1: {
      fontSize: "18px",
      textAlign: "left",
      marginTop: "12px",
      fontWeight: 700,
      fontFamily: "Switzer",
      lineHeight: "19.8px",
    },
    delteItem2: {
      textAlign: "right",
      marginTop: "12px",
      fontSize: "18px",
      fontWeight: 700,
      fontFamily: "Switzer",
      lineHeight: "19.8px",
      color: "#DC3545",
    },
    manageHeader: {
      "& .pageTitle": {
        marginLeft: "5px",
        fontFamily: "Switzer",
        fontWeight: 700,
        fontSize: isMobile ? "30px" : "42px",
        lineHeight: "46.2px",
        color: colorTheme?.text_color,
        padding: isMobile ? "0 0 18px 0" : "40px 0 18px 0",
      },
    },
    deleteDescription: {
      fontWeight: 400,
      fontFamily: "Switzer",
      fontSize: "18px",
      lineHeight: "27px",
      color: colorTheme?.text_description_color,
      marginLeft: "5px",
      textAlign: "left",
      marginBottom: isMobile ? "3rem" : "4rem",
    },
  }));
  const classes = useStyles();

  const handleClick = () => {
    setEdit(true);
  };

  return (
    <Paper className={isMobile ? classes.paperMobile : classes.paper}>
      <Box
        style={{
          width: "100%",
          height: isMobile.isMobile ? "100vh" : "100%",
          background: "#fff",
          backgroundColor: cardBackgroundColor,
        }}
      >
        {isMobile && header && showBackArrow && (
          <HeaderNavigation page={props.retailer} />
        )}
        <div className={classes.content}>
          <div className={classes.header}>
            <Typography
              className="pageTitle headerItem"
              align="left"
              variant="h3"
              component="h3"
              noWrap
            >
              Address
            </Typography>
            <div className={classes.headerItem} onClick={handleClick}>
              Edit
            </div>
          </div>
          <div className={isMobile && classes.profileBodyMob}>
            <ProfileWrapper
              formType="shipping"
              config={signupConfig}
              fields={formFields}
              retailerName={dpnInstance}
              editField={editMode}
              setEditField={setEdit}
              siteConfig={props.retailer}
              setCancel={() => setEdit(false)}
            />
          </div>
        </div>
      </Box>
    </Paper>
  );
}

export default ShippingAddress;
